import { render } from "./OverlayFile.vue?vue&type=template&id=7c6a2c1e"
import script from "./OverlayFile.vue?vue&type=script&lang=js"
export * from "./OverlayFile.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__